import {useIMask} from "vue-imask";

const Vue = require('vue');
const {createApp, ref, computed} = Vue;
import vueFilePond from "vue-filepond";
import {reactive} from "vue";
import {email, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import axios from 'axios';


const app = createApp({
    components: {
        FilePond: vueFilePond()
    },
    setup() {

        const isSent = ref(false);
        const isLoading = ref(false);

        const files = [];

        const state = reactive({
            name: '',
            phone: '',
            email: '',
            comments: ''
        })

        const phoneCheck = (value) => {

            if (value.includes('_')) {
                return false
            }

            // Очищаем номер телефона от лишних символов
            const cleanedValue = value.replace(/(?!^\+)\D/g, '')

            // Проверяем соответствие номеру телефона:
            // - Может начинаться с + и содержать от 1 до 3 цифр (код страны)
            // - Далее должны быть 10 цифр основного номера
            return /^(\+?\d{1,3})?\d{10}$/.test(cleanedValue)
        }

        const rules = {
            name: {required},
            phone: {required, phoneCheck},
            email: {required, email},
            comments: {}
        }

        const v$ = useVuelidate(rules, state)

        const {el: phoneEl, masked} = useIMask(
            {
                mask: '+7 (000) 000-00-00',
                lazy: true,
            }
        );

        const send = async () => {
            if (isLoading.value) {
                return
            }
            v$.value.$touch();

            if (v$.value.$invalid) {
                return;
            }

            isLoading.value = true;

            const response = await axios.post('/api/request/designers/create-bim-models', {
                name: state.name,
                phone: state.phone,
                email: state.email,
                comments: state.comments,
                files: files
            })

            if (response.data.success) {
                isSent.value = false;
            }

            isLoading.value = false;

        }

        return {
            state, v$,
            files,
            phoneEl,
            masked,
            isLoading,
            isSent,
            send
        }
    }
});

app.mount('#vue-page-designers__bim__request');

const faqBlock = document.querySelector('.js-page-designers__support__faq');

if(faqBlock) {
    const items = faqBlock.querySelectorAll('.js-page-designers__support__faq__item');

   items.forEach(item => {
       const question = item.querySelector('.js-page-designers__support__faq__item__question');
       const answer = item.querySelector('.js-page-designers__support__faq__item__answer');

       if(question && answer) {
           question.addEventListener('click', () => {
               question.classList.toggle('is-active');
               answer.classList.toggle('is-active');
           })
       }
   })
}